import { Option } from '../types';

export const filterOption = (option: Option, inputValue: string): boolean => {
  if (inputValue.length < 3) {
    return true;
  }

  return option.label.toLowerCase().includes(inputValue.toLowerCase());
};

export const filterOptionOnBE = (): boolean => {
  return true;
};
